import styled from '@emotion/styled';
import { Spin } from 'antd';
import type { FC } from 'react';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { IconSpinnerNoSpin } from '../BasicComponents/Icons';

export type ReloadButtonProps = {
  autoReloadEnabled: boolean;
  isReloading: boolean;
  onReload: () => Promise<void>;
};

export const ReloadButton: FC<ReloadButtonProps> = ({
  autoReloadEnabled,
  isReloading,
  onReload,
}) => {
  async function handleReloadClick() {
    if (isReloading) return;
    try {
      await onReload();
    } catch (err) {
      console.error('Failed to reload event info:', err);
    }
  }

  if (!autoReloadEnabled) return null;

  return (
    <ReloadButtonWrapper title={t('Reload')} {...onClickGenerator(() => handleReloadClick())}>
      {isReloading ? <Spin size="small" /> : <IconSpinnerNoSpin />}
    </ReloadButtonWrapper>
  );
};

const ReloadButtonWrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  height: 42px;
  width: 42px;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--base-color-50);
  cursor: pointer;
  font-weight: 600;
  margin: 10px;
  margin-left: 0;
  border-radius: 4px;
  text-align: center;
  color: ${({ disabled }) => (disabled ? 'var(--player-color-mid-grey)' : 'black')};
  border-color: ${({ disabled }) => (disabled ? 'var(--player-color-mid-grey)' : 'var(--base-color-50)')};
  cursor: ${({ disabled }) => (disabled ? 'inherit' : 'pointer')};

  &:hover {
    background-color: ${({ disabled }) => (disabled ? 'inherit' : 'var(--base-color-10)')};
  }
`;
